<template>
   
    <div> 
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 渠道管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>所有用户</el-breadcrumb-item>
            </el-breadcrumb>
        </div>  
        <el-card shadow="hover"  class="searchCard" >
             
                <span class="label-span">
                    <label class="label">手机号码</label> 
                    <el-input v-model.trim="query.phone" style="width:150px" placeholder="手机号码" class="handle-input mr15"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">渠道名称</label> 
                    <el-input v-model.trim="query.loginName" style="width:150px" placeholder="渠道名称" class="handle-input mr10"></el-input>   
                </span>
<!--                <span class="label-span">-->
<!--                    <label class="label">实名状态</label> -->
<!--                    <el-select v-model.trim="query.isSm" style="width:100px" placeholder="实名状态" class="handle-input mr10">-->
<!--                        <el-option value="" label="全部"  />  -->
<!--                        <el-option value="1" label="已实名"  /> -->
<!--                        <el-option value="0" label="未实名"  /> -->
<!--                    </el-select>   -->
<!--                </span>-->
                <span class="label-span">
                    <label class="label">账号状态</label> 
                    <el-select v-model.trim="query.status" style="width:100px" placeholder="账号状态" class="handle-input mr10">
                        <el-option value="" label="全部"  />  
                        <el-option value="1" label="已启用"  /> 
                        <el-option value="0" label="已封禁"  /> 
                    </el-select>   
                </span>
                <el-button type="success" icon="el-icon-search" class="mr10"  @click="handleSearch"> 搜 索 </el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" @click="refreshSearch"> 重 置 </el-button>
                <el-button  type="primary"  class="mr10"  @click="addBind" >添加渠道</el-button>  
                <!--<span class="closrSearchBtn" @click="changeI"  style="margin-left:30px;font-size:25px;line-height:35px;"><i :class="Ishow"></i></span>
                <el-button  type="primary" class="handle-del"  @click="changeGrade" >代理转移</el-button>--> 
                
        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <!-- :summary-method="getSummaries" show-summary -->
            <el-table  :height="theight"   :data="tableData"  class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  
             v-loading="loading"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >
                <!--<el-table-column type="selection" width="45" align="center"></el-table-column>
                
                <el-table-column prop="loginName" min-width="100" align="left" label="账户名">
                    <template slot-scope="scope" > 
                        <el-tag type="info" style="cursor:pointer;"  @click="loginNameEdit(scope.$index, scope.row)">
                            {{scope.row.loginName}}<i class="el-icon-edit"></i> 
                        </el-tag> 
                    </template>  
                </el-table-column>-->
                <el-table-column prop="id" width="60" align="center" label="ID"></el-table-column> 
                <el-table-column prop="phone"  min-width="115" align="center" label="手机号码"></el-table-column> 
                <el-table-column prop="loginName"   min-width="120" align="left" label="渠道名称"></el-table-column>
                <el-table-column prop="uid" min-width="160" align="left" label="关联员工">
                    <template slot-scope="scope" >
                    <span v-for="item in select3.option" v-if='scope.row.uid==item.optKey'>
                        {{item.optVal}}
                    </span>
                    </template>
                </el-table-column>
                <el-table-column prop="perRatio" min-width="160" align="left" label="分成比例">
                    <template slot-scope="scope" >
                        {{scope.row.perRatio}}%
                    </template>
                </el-table-column>
<!--                <el-table-column prop="email"  min-width="180" align="left" label="邮箱账号"></el-table-column>-->
<!--                <el-table-column prop="isSm"    min-width="80" align="center" label="实名信息">-->
<!--                    <template slot-scope="scope" >-->
<!--                        <el-tag :type="scope.row.isSm==1?'success':'info'" style="cursor:pointer;"  >-->
<!--                            {{scope.row.isSm==1?'已实名':'未实名'}}-->
<!--                        </el-tag>-->
<!--                        <el-tooltip v-if="scope.row.isSm==1" content="点击查看实名信息" placement="top">-->
<!--                            <i class="el-icon-lx-news" @click="smInfo(scope.row)" style="font-size:25px;"></i>-->
<!--                        </el-tooltip>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="status"  min-width="80" align="center" label="账号状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'正常':scope.row.info" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color="red"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>  
                <el-table-column prop="memCode" type="expand" width="100" label="API信息"> 
                    <template slot-scope="props">  
                        <div style="border: 1px dashed #409EFF;width:98%;margin:0 0.5%;font-size:12px;">
                            <p style=" color:#666;padding:15px 30px 10px;background:#ecf5ff">
                                <span>API文档：<el-link @click="copyLink('API文档','API文档：'+proDoc)"  type="primary" style="font-size:16px;" >{{proDoc}} </el-link> </span>
                            </p>
                            <p style=" color:#666;padding:10px 30px 10px;background:#ecf5ff">
                                <span>三方支付-API文档：<el-link @click="copyLink('三方支付-API文档','三方支付-API文档：'+'https://docs.qq.com/doc/DVFNyVm1uVkxPVktm')"  type="primary" style="font-size:16px;" >https://docs.qq.com/doc/DVFNyVm1uVkxPVktm </el-link> </span>
                            </p>
                            <p style=" color:#666;padding:5px 0px 10px; background:#ecf5ff"> 
                                <span style="margin-left:30px;">渠道 ID：
                                    <el-link @click="copyLink('渠道ID','mid：'+props.row.id)"  type="primary" style="font-size:16px;" >{{props.row.id}} </el-link>
                                </span>
                                <span style="margin-left:30px;">渠道密钥：
                                    <el-link type="primary" style="font-size:16px;" @click="copyLink('渠道密钥', 'appKey：'+props.row.secret)" >{{props.row.secret}} </el-link>
                                </span>
                                <span class='tableOperBtn' style="float:right;margin-right:30px;margin-top:-25px;" type="primary"
                                    @click="copyLink('API信息','API对接信息 【  API对接文档：'+proDoc+ ' ，mid：'+props.row.id+'，appKey：'+props.row.secret+'，报备域名：'+props.row.fb1+'，回调地址url：'+props.row.fb2+' 】')"
                                ><i class='el-icon-lx-copy'></i> API信息复制</span>
                                <br>
                                <span class='tableOperBtn' style="float:right;margin-right:30px;margin-top:15px;"   @click="handleApi(props.$index, props.row)" ><i class='el-icon-edit'></i> API对接配置</span>
                                
                            </p>
                            <p style=" color:#666;padding:5px 0px 15px; background:#ecf5ff">
                                <span style="margin-left:30px;">超时回调：
                                    <el-switch @change="handleOver(props.$index, props.row)"
                                        v-model="props.row.overPush"
                                        active-color=""
                                        inactive-color=""
                                        active-value="1"
                                        inactive-value="0">
                                    </el-switch>
                                </span> 
                                 <span style="margin-left:30px;">退订通知：
                                    <el-switch @change="handleOver(props.$index, props.row)"
                                        v-model="props.row.tdPush"
                                        active-color=""
                                        inactive-color=""
                                        active-value="1"
                                        inactive-value="0">
                                    </el-switch>
                                </span> 
                                <span style="margin-left:30px;">报备域名：
                                    <el-link @click="copyLink('报备域名','报备域名'+props.row.fb1)"  type="primary" style="font-size:16px;" >{{props.row.fb1}} </el-link>
                                </span>
                                <span style="margin-left:30px;">回调地址：
                                    <el-link @click="copyLink('回调地址','回调地址url：'+props.row.fb2)"  type="primary" style="font-size:16px;" >{{props.row.fb2}} </el-link>
                                </span> 
                            </p>
                        </div>   
                    </template> 
                </el-table-column>   
                <el-table-column prop="createTime"  min-width="160" align="center"  label="创建时间"> </el-table-column>
                <el-table-column prop="updateTime"  min-width="160" align="center"  label="更新时间"> </el-table-column>
                <el-table-column label="操作"  min-width="150" align="center" fixed="right" >
                    <template slot-scope="scope">  
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handleGoods(scope.$index, scope.row)" ><i class='el-icon-lx-settings'></i> 配置</span>
                    
                        <!--  <el-button-group> 
                            <el-button  type="success" plain  @click="handleGoods(scope.$index, scope.row)" >配置面板</el-button>  
                            <el-button  type="error" plain  @click="handleEdit(scope.$index, scope.row)" >资料设置</el-button>  
                            <el-button  type="success" plain  @click="handleDeduc(scope.$index, scope.row)" >产品扣量</el-button>   
                            <br> 
                            <el-button  type="warning" plain  @click="handlePlain(scope.$index, scope.row)" >预警风控</el-button> 
                            
                             <el-button  type="danger" plain  @click="handDelete(scope.$index, scope.row)" >删除</el-button> 
                        </el-button-group> -->
                    </template>
                </el-table-column>    
            </el-table>
            
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 50,500]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
        <el-dialog :close-on-click-modal="false" title="资料设置" :modal-append-to-body='false' :visible.sync="aesIdVisible" top="80px" width="570px">
            <el-form ref="form" :model="formL" label-width="80px">   
                <el-form-item label="渠道名称" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="formL.loginName"  placeholder="请输入修改渠道名称"></el-input> 
                </el-form-item> 
                <el-form-item label="手机号码"  style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="formL.phone" type="number" placeholder="请输入修改手机号" oninput ="value=value.replace(/[^\d]/g,'')"></el-input> 
                </el-form-item>
                <el-form-item label="登录密码" style="width:50%;display:inline-block;"  >
                    <el-input  v-model.trim="formL.loginPass"  placeholder="不更改留空"  ></el-input> 
                </el-form-item>
                <el-form-item label="关联员工" style="width:50%;display:inline-block;"  >
                    <el-select v-model.trim="formL.uid"  placeholder="选择员工"   filterable clearable @change="value=>uidChange(formL,value)">
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="分成比例" required style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input  v-model.trim="formL.perRatio" placeholder="请输入0-99的正整数"  :disabled="isCompanyManagement(formL.uid)"
                               oninput ="value=value.replace(/[^\d]/g,''); if(value.length>2) value=value.slice(0,2)" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
<!--                <el-form-item label="邮箱账号" style="width:50%;display:inline-block;"  >-->
<!--                    <el-input  v-model.trim="formL.email" type="text" placeholder="请输入修改邮箱号" ></el-input> -->
<!--                </el-form-item>-->
<!--                <el-form-item label="绑定角色" style="width:50%;display:inline-block;"  > -->
<!--                    <el-select v-model.trim="formL.rcode"  placeholder="选择角色" > -->
<!--                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> -->
<!--                    </el-select>-->
<!--                </el-form-item> -->
                <el-form-item label="消息通知" style="width:50%;display:inline-block;"  >
                    <el-tooltip :content="formL.msgStatus=='1'?'已开启':'未关闭'" placement="top">
                        <el-switch  
                            v-model="formL.msgStatus"
                            active-color=""
                            inactive-color=""
                            active-value="1"
                            inactive-value="0">
                        </el-switch>
                    </el-tooltip>
                </el-form-item>  
                <el-form-item label="账号类型" style="width:100%;display:inline-block;" >
                    <el-radio-group  v-model.trim="formL.memType" >
                        <el-radio-button label="0">普通账号</el-radio-button> 
                        <el-radio-button label="1">天猫账号</el-radio-button> 
                        <el-radio-button label="2">流量果账号</el-radio-button> 
                    </el-radio-group>   
                </el-form-item>
                <el-form-item v-if="formL.memType==1 || formL.memType==2" label="应用ID" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="formL.shopId"  placeholder="请输入应用ID"></el-input> 
                </el-form-item> 
                <el-form-item v-if="formL.memType==1 || formL.memType==2" label="应用密钥" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="formL.shopSecret"  placeholder="请输入应用密钥"></el-input> 
                </el-form-item> 
                <el-form-item v-if="formL.memType==1" label="授权token" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="formL.shopToken"  placeholder="请输入授权token"></el-input> 
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aesIdVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateInfo">确 定</el-button>
            </span>
        </el-dialog> 

        <el-dialog :close-on-click-modal="false" title="API配置" :modal-append-to-body='false' :visible.sync="apiVisible" top="80px" width="520px">
            <el-form ref="form" :model="form" label-width="90px">
                <el-form-item label="渠道ID" >
                    <el-input  v-model.trim="formL.id" disabled  style="width:100%"  ></el-input> 
                </el-form-item>
                <el-form-item label="渠道密钥" >
                    <el-button size="mini" class="el-icon-refresh" @click="setSecret()" style="margin-top:-120px"> 变更密钥</el-button>
                    <br>
                    <span style="width:94%;display:inline-block;background:#eee;padding:5px 10px;border-radius:8px;">{{formL.secret}}</span>
                </el-form-item> 
                <el-form-item required label="报备域名" >
                    <el-input  v-model.trim="formL.fb1"  style="width:100%" placeholder="多个域名以、分隔"></el-input> 
                </el-form-item>
                <el-form-item required label="回调地址" >
                    <el-input  v-model.trim="formL.fb2"  style="width:100%" placeholder="完整URL链接"></el-input> 
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="apiVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateApi">确 定</el-button>
            </span>
        </el-dialog> 
        <el-drawer :title="loginName+' - 配置面板'" :visible.sync="goodsVisible" direction="ttb" :append-to-body='true' width="100%" height="100%">
        <!--<el-dialog :title="loginName+' - 配置面板'" :modal-append-to-body='false' :visible.sync="goodsVisible" height="100%" top="0px" width="100%">-->
            <div style="padding:0px 20px 10px" >
                <span class="label-span">
                    <label class="label2">上游资源</label> 
                    <el-select v-model="query2.channelCode"  placeholder="上游资源" filterable style="width:150px;" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label2">产品名称</label> 
                    <el-input v-model.trim="query2.goodsName" placeholder="产品名称" style="width:180px;" class="handle-input mr10"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label2">产品编码</label> 
                    <el-input v-model.trim="query2.goodsCode" placeholder="产品编码" style="width:120px;" class="handle-input mr10"></el-input> 
                </span>  
                <el-button type="success"   @click="handleSearch2">搜索</el-button>
                <el-button type="error" class="mr15"   @click="refreshSearch2">重置</el-button>
                <el-button type="danger"  class="mr10"   @click="matchBatchNo" >取消分配</el-button> 
                <!-- <el-button type="warning"  class="mr10"   @click="comBatchSet" >结佣计算</el-button> -->
                <el-button type="primary"  class="mr10"   @click="matchBatch" >批量分配</el-button>  
                <el-tooltip  content="点击解开编辑权限" placement="top">
                    <i style="color:#fff;font-size:25px;vertical-align:middle;cursor:pointer;color: #409eff;float:right;margin-right:20px;" class='el-icon-edit-outline'  @click="setConfigEdit()"></i>
                </el-tooltip>
            
            <el-table   :data="tableData2"   class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange2" 
             v-loading="loading2" border  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >
                <el-table-column type="selection" min-width="40" align="center"></el-table-column> 
                <el-table-column prop="channelName"  width="110" align="left" label="上游资源"></el-table-column>
                <el-table-column prop="gid"  width="110" align="left" label="产品编码">
                    <template slot-scope="scope" >
                        <el-link type="error" style="font-size:12px" @click="copyLink('产品编码','产品编码:'+scope.row.goodsCode)" ><b>{{scope.row.goodsCode}}</b></el-link>
                    </template>  
                </el-table-column>  
                <el-table-column v-if="memType==1" prop="gid" min-width="100" align="left" label="下游编码">
                    <template slot-scope="scope" >
                        <input class='inputStyle' :disabled="editLock" @change="handleVal(scope.row)" v-model.trim="scope.row.memGoodsCode"   style="width:110px; "  >
                    </template>  
                </el-table-column>  
                <el-table-column prop="goodsName" min-width="160" align="left" label="产品名称">
                    <template slot-scope="scope" >
                        <el-link type="error" @click="copyLink('产品名称','产品名称:'+scope.row.goodsName)" style="font-size:12px;line-height:16px;">{{scope.row.goodsName}}</el-link> 
                    </template>
                </el-table-column>  
                <el-table-column prop="deducPercent"  width="110" align="left" label="扣量比例">
                    <template slot-scope="scope" >  
                        <el-input   :disabled="editLock" min="0" max="100" v-model.number="scope.row.deducPercent" @change="setDeduc(scope.row)" placeholder="百分比"  style="width:70px; " oninput="value = Math.max(0, Math.min(100, value.replace(/[^0-9]/g, '')))"
                        ></el-input> %
                       
                    </template>  
                </el-table-column> 
                <el-table-column prop="deducTime"  width="140" align="left" label="扣量设置时间">
                    <template slot-scope="scope" >  
                        <el-link style="font-size:12px;" @click="copyLink('扣量开始时间', scope.row.deducTime)" >{{scope.row.deducTime}}</el-link> 
                    </template> 
                </el-table-column> 
                <!--<el-table-column prop="limitConfig" width="130" align="right" label="限量信息">
                    <template slot-scope="scope" > 
                        <el-tooltip content="点击进行限单配置" placement="top">
                        <el-link  @click="limitConfig(scope.row)"  style='color:orange' v-if="scope.row.giveType==2">抢 {{scope.row.giveNum}} <span style="color:#999;">单/天</span></el-link>
                        <el-link @click="limitConfig(scope.row)" v-else style='color:green' >限  {{scope.row.giveNum}} <span style="color:#999">单/天</span></el-link>
                        </el-tooltip>
                    </template>  
                </el-table-column>   
                <el-table-column prop="isStop"   width="90" align="center" label="到量开关">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.isStop=='1'?'已到量':'未到量'" placement="top">
                            <el-switch @change="handleStatus3(scope.row)" :disabled="editLock"
                                v-model="scope.row.isStop"
                                active-color="red"
                                inactive-color="#67C23A"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>     
                <el-table-column prop="riskId" width="100" align="left" label="转化率风控">
                     <template slot-scope="scope" >  
                        <el-tooltip content="点击进行转化率风控配置" placement="top">
                            <el-link v-if="scope.row.riskPercent==0"  style='color:#999' @click="riskConfig(scope.row)"  >暂无风控 </el-link>
                            <el-link v-else @click="riskConfig(scope.row)"  style='color:orange'  > {{scope.row.riskNum}} - {{scope.row.riskPercent}}% </el-link>
                        </el-tooltip>
                    </template>   
                </el-table-column>
                <el-table-column prop="riskStatus"  width="90" align="center" label="风控状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.riskStatus=='1'?'风控关停':'风控通过'" placement="top">
                            <el-switch @change="handleStatus4(scope.row)" :disabled="editLock"
                                v-model="scope.row.riskStatus"
                                active-color="red"
                                inactive-color="#67C23A"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>    -->
                <el-table-column prop="channelComType" width="115" align="left" label="上游佣金">
                    <template slot-scope="scope" >
                        <span class='orangered'>￥{{scope.row.channelCom}}<span v-if="scope.row.channelComType==2"> X {{scope.row.channelComTimes}} 月</span></span> 
                       
                    </template>
                </el-table-column>  
                <el-table-column prop="isSm" width="100" align="left" label="结算类型">
                    <template slot-scope="scope" > 
                        <el-select v-model.trim="scope.row.goodsComType" :disabled="editLock" @change="handleVal(scope.row)" placeholder="请选择返佣类型" style="width:100%;"  > 
                            <el-option label="CPA" value="1" />
                            <el-option label="CPS" value="2" />      
                            <el-option label="其它" value="3" />      
                        </el-select>  
                    </template>  
                </el-table-column> 
                <el-table-column prop="isSm" min-width="120" align="left" label="产品结佣">
                    <template slot-scope="scope" > 
                        <p v-if="scope.row.goodsComType==2">  
                            <el-input  :disabled="editLock" v-model.trim="scope.row.goodsCom" @change="handleVal(scope.row)"  placeholder="单位元" style="width:70px; " oninput="value=value.replace(/[^0-9.]/g,'')"  ></el-input>
                            元 x
                            <el-input :disabled="editLock"  v-model.trim="scope.row.goodsComTimes" @change="handleVal(scope.row)" placeholder="月份"  style="width:70px; " oninput="value=value.replace(/[^\d]/g,'')"   ></el-input>
                            月
                        </p>  
                        <p v-else> 
                            <el-input :disabled="editLock"  v-model.trim="scope.row.goodsCom" @change="handleVal(scope.row)" placeholder="单位元" style="width:70px; "  oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input>
                            元
                        </p>   
                    </template>  
                </el-table-column>    
                <el-table-column prop="status" fixed="right" width="90" align="center" label="分配状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'已分配':'未分配'" placement="top">
                            <el-switch @change="handleStatus2(scope.row)" :disabled="editLock"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>   
                   
            </el-table> 
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10,20]"
                    :current-page="query2.pageIndex"
                    :page-size="query2.pageSize"
                    :total="pageTotal2"
                    @size-change="handleSizeChange2"
                    @current-change="handlePageChange2" 
                ></el-pagination>
            </div> 
            </div>
        </el-drawer>


        <el-drawer :title="goodsName+' - 限单配置'" :visible.sync="limitVisible" direction="rtl" :append-to-body='true'  height="60%">
            <v-content1></v-content1>
        </el-drawer>
        <el-drawer :title="loginName+' - '+goodsName+' - 转化率风控配置'" :visible.sync="riskVisible" direction="rtl" :append-to-body='true'  height="100%" >
             <v-content2></v-content2>
            <!--<div style="padding:20px 30px" v-loading="loadingR"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading">
                <el-form ref="form" :model="formR" label-width="150px" >
                    <p class="titleInfo" style="height:35px;line-height:35px;margin-bottom:25px;">下游渠道风控</p>
                    <span class="label-span" >
                        <label class="label">渠道风控值</label> 
                        <el-input  v-model.trim="formR.riskNum"  placeholder="渠道初始风控值" style="width:105px;" class="handle-input mr10"></el-input> 
                    </span>   
                    <span class="label-span"  >
                        <label class="label">渠道转化率</label> 
                        <el-input  v-model.trim="formR.riskPercent"  placeholder="渠道最低转化率监控" style="width:105px;" class="handle-input mr10"></el-input> %
                    </span>     
                    <p class="titleInfo" style="height:35px;line-height:35px;margin-top:15px;margin-bottom:25px;">资源产品风控</p> 
                    <span class="label-span"  >
                        <label class="label">整体风控值</label> 
                        <el-input  v-model.trim="formR.riskPercent"  placeholder="整体风控值" style="width:105px;" class="handle-input mr10"></el-input>
                    </span>   
                    <span class="label-span"  >
                        <label class="label">风控转化率</label> 
                        <el-input  v-model.trim="formR.riskPercent"  placeholder="最低转化率监控" style="width:105px;" class="handle-input mr10"></el-input> %
                    </span>   
                    <span class="label-span"  style="display:block;margin-top:10px">
                        <label class="label">风控级别</label> 
                        <el-radio-group  v-model.trim="formR.riskLevel" >
                            <el-radio-button label="0">资源级风控</el-radio-button> 
                            <el-radio-button label="1">产品级风控</el-radio-button> 
                        </el-radio-group>  
                    </span>   
                    <span class="label-span"  style="display:block;margin-top:10px">
                        <label class="label">转化率指标</label> 
                        <el-checkbox-group v-model="riskMems" size="mini" style="display:inline-block;margin-left:15px;">
                            <el-checkbox label="9" >订购成功</el-checkbox>
                            <el-checkbox label="6"  >回填成功</el-checkbox>
                            <el-checkbox label="-1" >订购失败</el-checkbox>
                        </el-checkbox-group>
                    </span>    
                        
                    
                </el-form>
                <el-button type="primary" style="margin-top:50px;" size="medium" @click="saveRiskConfig">保 存</el-button>
            </div> -->
        </el-drawer>

         

        <el-dialog :title="loginName+' - 产品扣量'" :modal-append-to-body='false' :visible.sync="deducVisible" top="40px" width="850px" @selection-change="handleSelectionChange2" >
            <div style="margin-top:-10px;" >
                <span class="label-span">
                    <label class="label2">上游资源</label> 
                    <el-select v-model="query2.channelCode"  placeholder="上游资源" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label2">产品名称</label> 
                    <el-input v-model.trim="query2.goodsName" placeholder="产品名称" style="width:180px;" class="handle-input mr10"></el-input> 
                </span>  
                <el-button type="success"  @click="handleSearch2">搜索</el-button>
                <el-button type="error" @click="refreshSearch2">重置</el-button> 
                
            </div>
            <el-table   :data="tableData2"  style="max-height:450px;overflow-y:scroll" class="table"  ref="multipleTable" header-cell-class-name="table-header"  
             v-loading="loading2"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" > 
                <el-table-column prop="channelName" min-width="100" align="left" label="上游资源"></el-table-column>
                <el-table-column prop="gid" width="130" align="left" label="产品编码">
                    <template slot-scope="scope" >
                        <el-link style="font-size:12px" @click="copyLink('产品编码','产品编码:'+scope.row.goodsCode)"   type="primary"><b>{{scope.row.goodsCode}}</b></el-link>
                    </template>  
                </el-table-column>  
                <el-table-column prop="goodsName" min-width="210" align="left" label="产品名称">
                    <template slot-scope="scope" >
                        <el-link @click="copyLink('产品名称','产品名称:'+scope.row.goodsName)" style="font-size:12px;line-height:16px;color:#be9d1d;">{{scope.row.goodsName}}</el-link> 
                    </template>
                </el-table-column>    
                
            </el-table> 
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10,20]"
                    :current-page="query2.pageIndex"
                    :page-size="query2.pageSize"
                    :total="pageTotal2"
                    @size-change="handleSizeChange2"
                    @current-change="handlePageChange2" 
                ></el-pagination>
            </div> 
        </el-dialog> 

        <el-dialog :title="loginName+' - 预警风控'" :modal-append-to-body='false' :visible.sync="plainVisible" top="40px" width="1050px" @selection-change="handleSelectionChange2" >
            <div style="margin-top:-10px;" >
                <span class="label-span">
                    <label class="label2">上游资源</label> 
                    <el-select v-model="query2.channelCode"  placeholder="上游资源" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label2">产品名称</label> 
                    <el-input v-model.trim="query2.goodsName" placeholder="产品名称" style="width:180px;" class="handle-input mr10"></el-input> 
                </span>  
                <el-button type="success"  @click="handleSearch2">搜索</el-button>
                <el-button type="error" @click="refreshSearch2">重置</el-button> 
                
            </div>
            <el-table   :data="tableData2"  style="max-height:450px;overflow-y:scroll" class="table"  ref="multipleTable" header-cell-class-name="table-header"  
             v-loading="loading2"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" > 
                <el-table-column prop="channelName" min-width="100" align="left" label="上游资源"></el-table-column>
                <el-table-column prop="gid" width="130" align="left" label="产品编码">
                    <template slot-scope="scope" >
                        <el-link style="font-size:12px" @click="copyLink('产品编码','产品编码:'+scope.row.goodsCode)"   type="primary"><b>{{scope.row.goodsCode}}</b></el-link>
                    </template>  
                </el-table-column>  
                <el-table-column prop="goodsName" min-width="210" align="left" label="产品名称">
                    <template slot-scope="scope" >
                        <el-link @click="copyLink('产品名称','产品名称:'+scope.row.goodsName)" style="font-size:12px;line-height:16px;color:#be9d1d;">{{scope.row.goodsName}}</el-link> 
                    </template>
                </el-table-column>    
                
            </el-table> 
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10,20]"
                    :current-page="query2.pageIndex"
                    :page-size="query2.pageSize"
                    :total="pageTotal2"
                    @size-change="handleSizeChange2"
                    @current-change="handlePageChange2" 
                ></el-pagination>
            </div> 
        </el-dialog> 

        <!-- 新建绑定弹出框 -->  
        <el-dialog :close-on-click-modal="false" title="辅助计算" :modal-append-to-body='false' :visible.sync="batchComVisible" width="260px" top="180px">
            
            结佣扣减：<el-input  type="text" placeholder="填写正整数"  oninput="value=value.replace(/[^\d]/g,'')"  v-model.trim="delece"   style="width:120px;" ></el-input> %
                 
            <span slot="footer" class="dialog-footer">
                <el-button @click="batchComVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveDelece">确 定</el-button>
            </span>
        </el-dialog> 
       
        <el-dialog :close-on-click-modal="false" title="添加渠道" :modal-append-to-body='false' :visible.sync="addVisible" width="570px">
            <el-form ref="form1" :model="form1" label-width="90px" @submit.native.prevent="saveForm">
                <el-form-item required label="渠道名称" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.loginName"  placeholder="请输入修改渠道名称"></el-input> 
                </el-form-item>
                <el-form-item required label="手机号码"  style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.phone" type="number" placeholder="请输入修改手机号" oninput ="value=value.replace(/[^\d]/g,'')"></el-input> 
                </el-form-item> 
                <el-form-item required label="登录密码" style="width:50%;display:inline-block;"  >
                    <el-input  v-model.trim="form1.loginPass"  placeholder="不更改留空"  ></el-input> 
                </el-form-item>
                <el-form-item label="关联员工" style="width:50%;display:inline-block;"  >
                    <el-select v-model.trim="form1.uid"  placeholder="选择员工"   filterable clearable @change="value=>uidChange(form1,value)">
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="分成比例" required style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input  v-model.trim="form1.perRatio" placeholder="请输入0-99的正整数"  :disabled="isCompanyManagement(form1.uid)"
                               oninput ="value=value.replace(/[^\d]/g,''); if(value.length>2) value=value.slice(0,2)" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
<!--                <el-form-item label="邮箱账号" style="width:50%;display:none;"  >-->
<!--                    <el-input  v-model.trim="form1.email" type="text" placeholder="请输入修改邮箱号" ></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="绑定角色" style="width:50%;display:inline-block;"> -->
<!--                    <el-select v-model.trim="form1.rcode"  placeholder="选择角色"   filterable clearable @clear="resetSelect" > -->
<!--                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> -->
<!--                    </el-select>-->
<!--                </el-form-item> -->
                <el-form-item label="消息通知" style="width:50%;display:none;"  >
                    <el-tooltip :content="form1.msgStatus=='1'?'已开启':'未关闭'" placement="top">
                        <el-switch  
                            v-model="form1.msgStatus"
                            active-color=""
                            inactive-color=""
                            active-value="1"
                            inactive-value="0">
                        </el-switch>
                    </el-tooltip>
                </el-form-item>  
                <el-form-item label="账号类型" style="width:100%;display:inline-block;" >
                    <el-radio-group  v-model.trim="form1.memType" >
                        <el-radio-button label="0">普通账号</el-radio-button> 
                        <el-radio-button label="1">天猫账号</el-radio-button> 
                        <el-radio-button label="2">流量果账号</el-radio-button> 
                    </el-radio-group>   
                </el-form-item>
                <el-form-item required v-if="form1.memType==1 || form1.memType==2" label="应用ID" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.shopId"  placeholder="请输入应用ID"></el-input> 
                </el-form-item> 
                <el-form-item required v-if="form1.memType==1 || form1.memType==2" label="应用密钥" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.shopSecret"  placeholder="请输入应用密钥"></el-input> 
                </el-form-item> 
                <el-form-item required v-if="form1.memType==1" label="授权token" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.shopToken"  placeholder="请输入授权token"></el-input> 
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog> 

        
        
       

    </div>
</template>

<script>
import vContent1 from '../../components/page/ComGoodsLimit.vue';
import vContent2 from '../../components/page/ComGoodsRisk.vue';
import bus from '../../components/common/bus';
import {fetchData,saveForm,updateSave,handelDelete,changeStatus,changeStatus2,changeStatus3,changeStatus4,changeVal,changeStatusBatch,setDeducPercent,changeOver} from '../../api/member';

import { fetchSelect as fetchSelect1, fetchSelect } from '../../api/operRole';
import {sendSmsCode} from '../../api/common';   
import {fetchData2} from '../../api/comGoods';
import {fetchSelect as fetchSelect6} from './channel';  //渠道名称
import { fetchSelect2} from '../../api/comApilimit';
import { fetchSelect as fetchSelect3, fetchUserById } from '../user/comUser';
import { isCompanyManagement } from '@/utils/userConfig';  //用户
export default {

    data() {
        return {
            isCompanyManagement,
            proLink:window.location.protocol+'//cl.yxwl1688.cn',
            proDoc:window.location.protocol+'//docs.qq.com/doc/DRXVjc2pXempEZkRJ',
            isSubmitting: false, // 是否正在提交
            Ishow:'el-icon-caret-bottom',
            closeSearch:'',
            Timeout:'', 
            theight:'550px',
            theight2:'550px',  
            delece:'10',
            memType:'',
            riskMem:[],
            editLock:true,
            limitVisible:false,
            loading:false,
            loading2:false,
            aesIdVisible:false,
            apiVisible:false,
            operVisible:false,
            editVisible: false,
            loginVisible:false,
            addVisible:false,
            exchangeVisible:false,
            operRidVisible:false,
            stationVisible:false,
            goodsVisible:false,
            deducVisible:false,
            plainVisible:false,
            batchComVisible:false,
            riskVisible:false,
            loadingR:false,
            riskMems:[9],
            formR:{},
            loginName:'',
            goodsName:'',
            select:{ option:'',  },  
            select1:{ option:'',  },  
            select2:{ option:'',  },  
            select3:{ option:'',  },
            select6:{ option:'',  },
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
            }, 
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            query2:{
                pageIndex: 1,
                pageSize: 10, 
                memId:'',
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            multipleSelection2: [],
            delList: [], 
            delList2: [], 
            pageTotal: 0,
            pageTotal2: 0,
            form2: {  
                shopCode:'',
                ids:'',
                names:'',
            },
            form: {   
                ids:'',
                names:'',
            },
            formG:{

            },
            formL:{phone:'',loginName:'',secret:'',},
            form1: {memType:'0',msgStatus:'0',loginPass:'yxwl123456','rcode':"0cb4551bbb8f"
            }, 
            form3: {  
            },
            form4:{},
            idx: -1,
            id: -1
        };
    },
    created() { 
    }, 
    components: { 
        vContent1,
        vContent2 
    },
    //页面加载方法
    mounted: function () { 
        this.getSelect();
        this.getSelect3();
        this.getData();
    },

    methods: { 
        changeI(){  
                if(this.Ishow == 'el-icon-caret-bottom'){ 
                    this.Ishow = 'el-icon-caret-top';
                    this.closeSearch=false;
                }else{
                    this.Ishow='el-icon-caret-bottom'; 
                     this.closeSearch=true;
                }
            }, 
            getSelect(){ 
                this.select.option = ''; 
                fetchSelect(this.select).then(res => {  
                    if(res.code=='200'){  
                        this.select.option = res.data; 
                    }
                });
            },   

            setConfigEdit(){ 
                if(this.editLock){
                    this.$confirm('解开编辑权限后，修改的所有数据都将实时保存，确定要解开吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.editLock = false;
                    }) 
                }else{
                    this.editLock = true;
                
                }
            },
            delMem(){
                const length = this.multipleSelection.length; 
                if(length===0){
                    this.$message.error("请勾选要注销账号的渠道");
                    return;
                } 
                let ids = ''; 
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    ids += this.multipleSelection[i].id + ','; 
                } 
                this.form4.id = ids.substr(0,ids.length-1);   
                this.$confirm('注销后渠道数据将全部清空，确定要注销账号吗？', '提示', {
                    type: 'warning'
                }).then(() => {  
                    delMemberDate(this.form4).then(res => {  
                        if(res.code=='200'){ 
                            this.$message.success("渠道账号已注销成功！"); 
                            this.getData(); 
                        }else{ 
                            this.$message.error(res.message);
                        }  
                    });
                }) 
        },
        matchBatch(){ 
            const length = this.multipleSelection2.length; 
            if(length===0){
                this.$message.error("请勾选需要开启分配的行");
                return;
            }  
            let data = {};
            let ids = ''; 
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection2[i].id + ','; 
            }
            ids = ids.substr(0,ids.length-1);   
            data.ids = ids;
            data.status='1'; 
            this.$confirm('确定要分配吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading2 = true;
                setTimeout(() => {
                    this.loading2 =false; 
                }, 1500); 
                changeStatusBatch(data).then(res => {
                    this.loading2 = false;
                    if(res.code=='200'){ 
                        this.handleSearch2();
                        this.multipleSelection2 = [];
                        this.$notify({ title: '成功', message: '分配成功',duration: 1000, type: 'success' }); 
                        
                    }else{ 
                        this.$notify({ title: '失败', message: '分配失败：'+res.message,duration: 5000, type: 'error' });  
                    }  
                })
            })
        },
        matchBatchNo(){ 
            const length = this.multipleSelection2.length; 
            if(length===0){
                this.$message.error("请勾选需要取消分配的行");
                return;
            } 
            
            let data = {};
            let ids = ''; 
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection2[i].id + ','; 
            }
            ids = ids.substr(0,ids.length-1);   
            data.ids = ids;
            data.status='0'; 
            this.$confirm('确定取消分配吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading2 = true;
                setTimeout(() => {
                    this.loading2 =false; 
                }, 1500); 
                changeStatusBatch(data).then(res => {
                    this.loading2 = false;
                    if(res.code=='200'){ 
                        this.multipleSelection2 = [];
                        this.handleSearch2();
                        this.$notify({ title: '成功', message: '分配成功',duration: 1000, type: 'success' }); 
                        
                    }else{ 
                        this.$notify({ title: '失败', message: '分配失败：'+res.message,duration: 5000, type: 'error' });  
                    }  
                })
            });
        },
        comBatchSet(){
            const length = this.multipleSelection2.length; 
            if(length==0){
                this.$message.error("请勾选需要辅助计算的行");
                return; 
            } 
            this.batchComVisible = true;
        },
        saveDelece(){  
            this.batchComVisible = false;
            this.loading2 = true;
            for(let j = 0; j < this.tableData2.length; j++){
                for (let i = 0; i < this.multipleSelection2.length; i++) {      
                    if( this.tableData2[j].id==this.multipleSelection2[i].id){
                        var goodsCom = parseFloat((100-this.delece)*0.01 * this.tableData2[j].channelCom).toFixed(2); 
                        this.$set(this.tableData2[j], 'goodsCom',goodsCom);  
                        changeVal(this.tableData2[j]).then(res => {   
                            if(res.code=='200' && i==this.multipleSelection2.length-1){ 
                                this.loading2 = false;
                                this.multipleSelection2 = [];
                                this.$notify({ title: '成功', message: '辅助计算设置成功',duration: 1000, type: 'success' });
                            }else{
                                this.$notify({ title: '失败', message: '辅助计算设置失败'+res.message,duration: 5000, type: 'error' });  
                            }
                        });
                    }
                }
                
            } 
             
        },
        handleVal(row){
            changeVal(row).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.goodsName+'设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: row.goodsName+'设置失败：'+res.message,duration: 5000, type: 'error' }); 
                }
            });
        },
        setDeduc(row){
            if(row.deducPercent>100){
                this.$message.error(row.goodsName+'扣量值不能超过100');
                return;
            }
            if (!row.deducPercent){
                row.deducPercent = 0;
            }
            setDeducPercent(row).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: row.goodsName+'扣量值设置成功',duration: 1000, type: 'success' });
                }else{ 
                    this.$notify({ title: '失败', message:row.goodsName+'扣量值设置失败：'+res.message,duration: 5000, type: 'error' });
                }
            }); 
        },
        handleStatus2(row){
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "取消分配"; 
            }else{ 
                row.status = '0';
                tips = "分配"; 
            }
            this.$confirm('确认'+tips+this.loginName+"-"+row.goodsName+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                row.memId = row.mid;
                changeStatus2(row).then(res => {   
                    if(res.code=='200'){  
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.status=='0'){ 
                            row.status='1'   
                        }else{ 
                            row.status='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        },
        limitConfig(row){
            changeStatus2(row).then(res => {   
                if(res.code=='200'){    
                    this.goodsName = row.goodsName;
                    this.limitVisible = true;
                    setTimeout( () => {
                        bus.$emit('limit-method', res.data);
                    }, 500)  
                }else{ 
                    this.$message.error( '限单面板调用失败'); 
                }
            });
        }, 
        riskConfig(row){ 
            this.goodsName = row.goodsName;
            this.riskVisible = true;
            setTimeout( () => {
                bus.$emit('risk-method', row.goodsCode);
            }, 500)  
            /*
            this.formR = row;   
            this.riskMems = row.riskMem.split(",");  
            this.riskVisible = true;   */ 
        },
        saveRiskConfig(){ 
            this.loadingR = true;
            this.formR.riskMem =  this.riskMems.join();
            if(this.formR.riskMem.charAt(0) === ','){
                this.formR.riskMem = this.formR.riskMem.substring(1);
            }
            changeStatus4(this.formR).then(res => {   
                this.loadingR = false;
                if(res.code=='200'){   
                    this.riskVisible = false;    
                    this.$notify({ title: '成功', message: this.loginName+"-"+this.formR.goodsName+'转化率风控配置成功',duration: 1000, type: 'success' }); 
                }else{ 
                    this.$notify({ title: '失败', message: this.loginName+"-"+this.formR.goodsName+'转化率风控配置失败：'+res.message,duration: 5000, type: 'error' }); 
                }
            });
        },
        handleStatus3(row){
            var tips ;
            var content;
            if(row.isStop=='0'){ 
                row.isStop='1';
                tips = "关闭到量"; 
            }else{ 
                row.isStop = '0';
                tips = "开启到量"; 
            }
            this.$confirm('确认'+tips+this.loginName+"-"+row.goodsName+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.isStop=='0'){ 
                    row.isStop='1' 
                }else{ 
                    row.isStop='0' 
                }
                row.memId = row.mid;
                changeStatus3(row).then(res => {   
                    if(res.code=='200'){  
                        
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' });
                        if(row.isStop==0){ 
                            this.$confirm("立即对"+row.goodsName+"进行限单数量调整？") .then(() => { 
                                this.goodsName = row.goodsName;
                                this.limitVisible = true; 
                                setTimeout( () => {
                                    bus.$emit('limit-method', res.data);
                                }, 500) 
                            });
                        } 
                    }else{
                        if(row.isStop=='0'){ 
                            row.isStop='1' 
                        }else{ 
                            row.isStop='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' }); 
                    }
                });
            });
        }, 

        handleStatus4(row){
            var tips ;
            var content;
            if(row.riskStatus=='0'){ 
                row.riskStatus='1';
                tips = "重启风控"; 
            }else{ 
                row.riskStatus = '0';
                tips = "风控关停"; 
            }
            this.$confirm('确认'+tips+this.loginName+"-"+row.goodsName+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.riskStatus=='0'){ 
                    row.riskStatus='1' 
                }else{ 
                    row.riskStatus='0' 
                }
                row.memId = row.mid;
                changeStatus4(row).then(res => {   
                    if(res.code=='200'){   
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.riskStatus=='0'){ 
                            row.riskStatus='1' 
                        }else{ 
                            row.riskStatus='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        }, 
       

        setSecret(){ 
            this.$confirm('确认变更密钥吗？', '提示', {
                type: 'warning'
            }).then(() => {
            var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";  
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); 
                s[8] = s[13] = s[18] = s[23] = "-"; 
                var uuid = s.join("").replaceAll("-",""); 
                this.formL.secret = uuid; 
            });
        },
        
         
        copyLink(name,text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },
        //排序弹窗开启
        handleEdit(index,row){ 
            this.formL = row; 
            this.formL.loginPass = "";
            this.aesIdVisible = true;
        },
        handleApi(index,row){ 
            this.formL = row;  
            this.apiVisible = true;
        },
        handleGoods(index,row){  
            //查询列表数据 
            this.loginName = row.loginName;
            this.memType = row.memType;
            this.query2.memId = row.id; 
            this.getSelect6(); 
            this.getSelect2();
            this.formG = row;   
            this.goodsVisible = true; 
            this.editLock = true;
            this.getData2();
        }, 
        handleDeduc(index,row){  
            //查询列表数据
            this.loading =true;
            this.loginName = row.loginName;
            this.query2.memId = row.id;
            this.getData2();
            this.getSelect6();
            this.formG = row;  
            setTimeout(() => {
                this.loading =false;
                this.deducVisible = true;
            }, 500); 
            
        }, 

        handlePlain(index,row){  
            //查询列表数据
            this.loading =true;
            this.loginName = row.loginName;
            this.query2.memId = row.id;
            this.getData2();
            this.getSelect6();
            this.formG = row;  
            setTimeout(() => {
                this.loading =false;
                this.plainVisible = true;
            }, 500); 
            
        }, 
    
        getSelect1(){ 
            this.select1 = {};
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {};
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        },
        getSelect6(){
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {
                if(res.code=='200'){
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },

        getSelect3(){
            fetchSelect3({'perCodeS':'DownsBusiness,CompanyManagement'}).then(res => {
                if(res.code=='200'){
                    this.$set(this.select3, 'option', res.data);
                }
            });
        },
       
        saveStation(){
            let data = {};
            data.stationId = this.stationId;
            data.mid = this.mid; 
            data.fid = this.form4.fid;
            data.id = this.form4.id;
            updateStation(data).then(res => {
                if(res.code=='200'){
                    this.stationVisible = false;
                    this.$message.success("变更成功"); 
                    this.getData();
                }else{ 
                    this.$message.error("变更失败"); 
                } 
            });
        },
        uidChange(form,value){
            if (!value || isCompanyManagement(value)){
                this.$set(form,"perRatio","0");
                return;
            }
            this.getUser(value,user=>{
                this.$set(form,"perRatio",user.pnum);
            });
        },
        getUser(userId,fun){
            fetchUserById({id:userId}).then(res=>{
                if (res.code == '200') {
                    let user = res.data;
                    if (fun){
                        fun(user);
                    }
                }
            })
        },
        //排序弹窗开启
        loginNameEdit(index,row){
            this.form = row; 
            this.loginVisible = true;
        },
        editOper(row){
            this.form2 = row;
            this.operVisible = true;
        },  
        //更改分销权
        saveOper(){
            
            let data = {};
            data.id = this.form2.id;
            data.rid = this.form2.rid;
            data.stationId = this.stationId;
            data.mid = this.mid; 
            updateSave(data).then(res => {
                if(res.code=='200'){
                    this.operVisible = false;
                    this.$message.success("变更成功"); 
                    this.getData();
                }else{ 
                    this.$message.error("变更失败"); 
                } 
            });
        },
         
        //排序保存
        saveAesId(){
            let data = {};
            data.stationId = this.stationId;
            data.mid = this.mid;
            data.id = this.form.id;
            data.phone = this.formL.phone;
            updateSave(data).then(res => {
                if(res.code=='200'){ 
                    this.aesIdVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
        },
        
        updateInfo(){   
            updateSave(this.formL).then(res => {
                if(res.code=='200'){ 
                    this.aesIdVisible = false;
                    this.$message.success("修改成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
        },
        updateApi(){
            let data  = {};
            data.id = this.formL.id;
            data.secret = this.formL.secret;
            data.fb1 = this.formL.fb1;
            data.fb2 = this.formL.fb2; 
            data.fb3 = this.formL.fb3; 
            updateSave(data).then(res => {
                if(res.code=='200'){ 
                    this.apiVisible = false;
                    this.$message.success("修改成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
        }, 
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            this.theight = '540px'; 
            columns.forEach((column, index) => {
            if (index === 1) {//只找第一列放合计
                sums[index] = '统计';
                return;
            } 
            if(index < 10 ){
               sums[index] = '';
               return;
            } 
            const values = data.map(item => Number(item[column.property]));//把对应一列中的之全部取出，放到一个数组中
            if (!values.every(value => isNaN(value))) {//如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
                sums[index] = values.reduce((prev, curr) => {
                console.log(prev, curr);
                const value = Number(curr);//将values中的每个值转换为number类型
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
                }, 0);  
                if(index == 12){ 
                    sums[index] = parseFloat(sums[index]).toFixed(2);  
                }
            } else {
                sums[index] = ''
            }
            });
            window.setTimeout(() => { 
                this.theight = this.theight2; 
            }, 500) ;
            return sums; 
        },
        // 触发搜索按钮

        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        handleSearch2() { 
            this.getData2();
        },

        //重置按钮
        refreshSearch(){  
            this.$set(this.query, 'isSm'); 
            this.$set(this.query, 'phone'); 
            this.$set(this.query, 'loginName');  
            this.$set(this.query, 'status');   
            this.handleSearch();
        }, 

        //重置按钮
        refreshSearch2(){ 
            this.$set(this.query2, 'channelCode'); 
            this.$set(this.query2, 'goodsName');    
            this.$set(this.query2, 'goodsCode');    
            this.handleSearch2();
        }, 

       

         //刷新
        refresh(){
            history.go(0); 
        },

        //查询
        getData(){
            // 获取列表数据  
            fetchData(this.query).then(res => {   
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;   
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0; 
                } 
                
            });
        },
        getData2(){
            // 获取列表数据  
            this.loading2=true;  
            fetchData2(this.query2).then(res => {   
                this.loading2=false; 
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal ;    
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0; 
                } 
                
            });
        },

        //发送验证码
        sendCode(){ 
            //正则匹配手机号
            const phone = this.form1.phone;
            const reg =/^[1][3-9][0-9]{9}$/;
            if(!reg.test(phone)){
                this.$message.error("请输入正确的手机号"); 
                return;
            }  
            //发送短信按钮倒计时提示  
            var that = this;
            var times = 59;
            this.sendSms.disabled = true;
            this.sendSms.type='info';
            this.sendSms.color ="color:#333";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = this.mid;
            this.sendSms.stationId = this.stationId; 
            this.sendSms.loginName = this.loginName; 
            this.sendSms.phone = phone;   
            this.sendSms.code = "-1";
            sendSmsCode(this.sendSms).then(res => {
                if(res.code=='200'){ 
                    this.sendSms.code = res.data.code;
                    this.$message.success('发送成功'); 
                    this.getData();
                }else{ 
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                } 
            }); 
        },
   
        // 删除
        handDelete(index, row) {  
            this.form.gid=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.addVisible = false;
                        this.$message.success('删除成功'); 
                        this.query.pageIndex = this.query.pageIndex-1;
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.success(res.message); 
                    } 
                });
            }) 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        handleSelectionChange2(val) {
            this.multipleSelection2 = val; 
        },
        //更改权限
        changeOper() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要变更角色的用户");
                return;
            }  
            let ids = '';
            let names = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ',';
                names += this.multipleSelection[i].realName + '，';
            } 
            this.form3.ids = ids.substr(0,ids.length-1);
            this.form3.names = names.substr(0,names.length-1);  
            this.operRidVisible = true;
        },
       
        //批量更改分销权
        saveRidOper(){
            let data = {};
            data.ids = this.form3.ids;
            data.rid = this.form3.rcode;
            data.stationId = this.stationId;
            data.mid = this.mid; 
            changeRole(data).then(res => {
                if(res.code=='200'){
                    this.operRidVisible = false;
                    this.$message.success("变更成功"); 
                    this.getData();
                }else{ 
                    this.$message.error("变更失败"); 
                } 
            });
        },
        handleStatus(index,row){   
            let that = this;
            if(row.status==0){ 
                that.$prompt('请输入封禁'+row.loginName+'原因（不超过50个字）', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',  
                    }).then(({ value }) => { 
                        that.changeStatus(value,row);     
                }).catch(() => {
                       row.status='1'; 
                });
            }else{
                that.changeStatus("-",row);  
            } 
        },
        handleOver(index,row){   
            changeOver(row).then(res => { 
                if(res.code=='200'){  
                    this.$message.success(res.message);  
                }else{  
                    this.$message.error(res.message); 
                }  
            }); 
        },
        changeStatus(msg,row){ 
            row.info ="封禁原因："+ msg; 
            changeStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    if(row.status==1){
                        row.status = 0;
                    }else{
                        row.status = 1;
                    }
                    this.$message.error(res.message); 
                }  
            }); 
        },
        
        // 新增代理
        addBind() {
            this.getSelect(); 
            this.addVisible = true;
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.loginName ){
                this.isSubmitting = false;
                this.$message.error("请填写渠道名称");
                return;
            } 
            if( !this.form1.phone  ){
                this.isSubmitting = false;
                this.$message.error("请填写手机号");
                return;
            }
           /* if( !this.form1.rcode  ){
                this.isSubmitting = false;
                this.$message.error("请选择角色");
                return;
            }*/
           /* if( !this.form1.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form1.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            } */
            if( !this.form1.loginPass){
                this.isSubmitting = false;
                this.$message.error("请输入初始密码");
                return;
            }
            if( !this.form1.perRatio ){
                this.isSubmitting = false;
                this.$message.error("请填写分成比例");
                return;
            }
            this.loading = true; 
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){ 
                    this.addVisible = false;
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },
        
        // 保存更改
        saveEdit() { 
            if( !this.form.gid){
                this.$message.error("请选中要变更的等级");
                return;
            }  
            this.form.mid = this.mid;
            this.form.stationId = this.stationId;  
            changeForm(this.form).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>  
<style>
.el-drawer.rtl{
    width:60% !important;
}
.inputStyle{
    height:28px; 
    text-align:center; 
    border:none;
    border-bottom:1px solid orange; 
    background: none;
    color:orange;
}
.inputStyle::placeholder{
    color:#ddd;
}
.inputStyle:focus {
    outline:none;
    border-bottom:2px solid red; 
}
.el-drawer__header{
    margin-bottom:25px;
}
.ttb{
    height:100% !important;
}
.tableScopeSwitch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
}
/*打开时文字位置设置*/
.tableScopeSwitch .el-switch__label--right {
    z-index: 1;
    right: -10px;    /*不同场景下可能不同，自行调整*/
}
/*关闭时文字位置设置*/
.tableScopeSwitch .el-switch__label--left {
    z-index: 1;
    left: 20px;    /*不同场景下可能不同，自行调整*/
}
/*显示文字*/
.tableScopeSwitch .el-switch__label.is-active {
    display: block;
}
.tableScopeSwitch.el-switch .el-switch__core,
.el-switch .el-switch__label {
    width: 60px !important;    /*开关按钮的宽度大小*/
} 

.el-radio-button--small .el-radio-button__inner{
    font-size:15px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}


.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
} 
.demo-table-expand {
    font-size: 0;
    width:100%; 
  }
  .demo-table-expand label {
    width: 70px;
    float: left;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0; 
    width:100%;
    float: right;
  }
  .demo-table-expand{
      margin-left:50px;
  }
  .el-table__expand-icon{ 
        margin-left: -17px;
        margin-top: -5px;
         -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    } 
    
</style>
<style scoped>
.label-span{
    display: inline-block;
    height: 45px;
}
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
 
  .mr10 {
        margin-right: 10px;
        margin-left:0;
    }
    .mr15 {
        margin-right: 15px;
    } 
    
    

    :v-deep .el-icon-arrow-right:before { 
        color: #1890ff;

        font-size: 20px;

        font-weight: 700px; 
    }

    ::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
        
        content: "查看";
        font-size:15px;
        color:#409EFF; 
        text-align: center;
    } 
    ::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before{
        content: "收起";
        font-size:15px;
        color:#999; 
        text-align: center;
    }

      .shopCss{
        margin:-20px 0 15px 0px;
        width:100%;
        min-height:90px;
        padding:10px 15px; 
        color: #999;
        font-size: 16px;
    } 
    .shopLinkCss{
        display:inline-block;
        height:35px;
        line-height:35px;
        color:#409EFF;font-size:13px;
    }
 
@media screen and (max-width:999px){
    
    .shopCss{
        margin-top:15px;
        width:100%;height:180px;padding:1% 2%;
        background:#ecf5ff !important;
         color: #999;
    } 
    .shopLinkCss{
        display:block;
        color:#409EFF;font-size:17px;
    }
}
  
    
</style> 
